"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));

var _reactTether = _interopRequireDefault(require("react-tether"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var attachments = {
  top: 'bottom center',
  bottom: 'top center',
  left: 'middle right',
  right: 'middle left'
};
var targetAttachments = {
  top: 'top center',
  bottom: 'bottom center',
  left: 'middle left',
  right: 'middle right'
};

var Tooltip =
/*#__PURE__*/
function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tooltip).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "el", null);

    _defineProperty(_assertThisInitialized(_this), "state", {
      show: _this.props.show || false,
      // only used to prevent Tether from rendering on the first render due to perf issues.
      showInitial: _this.props.show || false
    });

    _defineProperty(_assertThisInitialized(_this), "setShowInitial", function () {
      _this.setState({
        showInitial: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setShowFlag", function (value) {
      var show = _this.props.show !== undefined ? _this.props.show : value;

      _this.toggleTether(show);

      _this.setState({
        show: show
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleTether", function (enable) {
      if (_this.tether) {
        if (enable) {
          _this.tether.enable();

          _this.tether.position();
        } else {
          _this.tether.disable();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "open", function () {
      _this.debouncedClose.cancel();

      _this.setShowFlag(true);
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this.debouncedOpen.cancel();

      _this.setShowFlag(false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (e) {
      // don't count clicks in the tooltip as "outside" clicks
      if (_this.el && _this.el.contains(e.target)) {
        return;
      }

      _this.props.onClickOutside && _this.props.onClickOutside();
    });

    _defineProperty(_assertThisInitialized(_this), "attachTether", function (tether) {
      return _this.tether = tether;
    });

    _defineProperty(_assertThisInitialized(_this), "attachElement", function (el) {
      return _this.el = el;
    });

    _this.debouncedClose = (0, _lodash["default"])(_this.close, 50);
    _this.debouncedOpen = (0, _lodash["default"])(_this.open, props.delay);
    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.state.show) {
        this.toggleTether(false);
      }
    } // Necessary since rerendering wipes the knowledge of the tether being disabled

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!this.state.show) {
        this.toggleTether(false);
      }
    } // If show is passed in, it should always use that value.

  }, {
    key: "render",

    /* eslint-enable no-return-assign */
    value: function render() {
      var _this$props = this.props,
          contents = _this$props.contents,
          direction = _this$props.direction,
          style = _this$props.style,
          className = _this$props.className,
          containerClassName = _this$props.containerClassName,
          variety = _this$props.variety,
          tooltipStyle = _this$props.tooltipStyle,
          constraints = _this$props.constraints;
      var _this$state = this.state,
          show = _this$state.show,
          showInitial = _this$state.showInitial;
      var isPopover = variety === 'popover';
      var popover = isPopover ? {
        display: 'block'
      } : {};

      if (showInitial || show) {
        return _react["default"].createElement(_reactTether["default"], {
          ref: this.attachTether,
          classPrefix: "tether-tooltip",
          attachment: attachments[direction],
          targetAttachment: targetAttachments[direction],
          constraints: constraints
        }, _react["default"].createElement("div", {
          style: _objectSpread({
            display: 'inline-block'
          }, style),
          onMouseEnter: this.debouncedOpen,
          onMouseOver: this.debouncedOpen,
          onMouseOut: this.debouncedClose,
          className: containerClassName
        }, this.props.children), _react["default"].createElement("div", {
          className: "".concat(variety, " fade ").concat(show ? 'in' : '', " ").concat(className),
          role: "tooltip",
          ref: this.attachElement,
          style: _objectSpread({
            visibility: show ? 'visible' : 'hidden'
          }, popover, {}, tooltipStyle),
          onMouseEnter: this.debouncedOpen,
          onMouseOver: this.debouncedOpen,
          onMouseOut: this.debouncedClose
        }, _react["default"].createElement("div", {
          className: variety === 'tooltip' ? 'tooltip-arrow' : 'arrow'
        }), _react["default"].createElement("div", {
          className: isPopover ? 'popover-content' : 'tooltip-inner'
        }, contents)));
      }

      return _react["default"].createElement("div", {
        style: _objectSpread({
          display: 'inline-block'
        }, style),
        onMouseEnter: this.setShowInitial,
        onMouseOver: this.setShowInitial,
        className: containerClassName
      }, this.props.children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.show !== undefined) {
        return {
          show: nextProps.show
        };
      }

      return null;
    }
  }]);

  return Tooltip;
}(_react.Component);

Tooltip.propTypes = {
  children: _propTypes["default"].node.isRequired,
  contents: _propTypes["default"].node,
  direction: _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left']),
  show: _propTypes["default"].bool,
  onClickOutside: _propTypes["default"].func,
  style: _reactStyleProptype["default"],
  tooltipStyle: _reactStyleProptype["default"],
  className: _propTypes["default"].string,
  containerClassName: _propTypes["default"].string,
  variety: _propTypes["default"].oneOf(['tooltip', 'popover']),
  constraints: _propTypes["default"].arrayOf(_propTypes["default"].object),
  delay: _propTypes["default"].number
};
Tooltip.defaultProps = {
  direction: 'top',
  className: '',
  containerClassName: '',
  tooltipStyle: {},
  variety: 'tooltip',
  constraints: [{
    to: 'window',
    attachment: 'together',
    pin: ['left', 'right']
  }],
  delay: 0
};

var _default = (0, _reactClickOutside["default"])(Tooltip);

exports["default"] = _default;